import React, { useEffect, useState } from "react";
import { Radio, Space, Tabs } from "antd";
import { TbCaretRight } from "react-icons/tb";
import GifPlayer from "react-gif-player";
import { color } from "framer-motion";
import assImage from "../../Assets/download.png";
import nineImage from "../../Assets/9000jobs.png";
import talguuImage from "../../Assets/talguu.png";
import ivrImage from "../../Assets/ivr.png";

import anima from "../../Assets/anima.gif";
import ivr from "../../Assets/Ivr.gif";
import talguu from "../../Assets/talguu.gif";
import ninejobs from "../../Assets/9000jobs.gif";
import "animate.css";
import "./MainProject.scss";

export const MainProject = () => {
  const [play, setPlay] = useState(false);
  const handleToggle = () => {
    console.log("called", play);
    setPlay(!setPlay);
  };
  const buttonText = play ? "Pause" : "Play";

  return (
    <div
      name="work"
      className=" md:flex flex-col justify-center items-center gap-32 hidden"
    >
      <div className="w-2/3 flex flex-col-2 gap-2  justify-start items-start ">
        <div className="w-1/2  hover:scale-105 hover:z-20">
          <GifPlayer
            gif={ivr}
            still={ivrImage}
            className="w-[450px] h-[350px] rounded-lg z-20"
          />
        </div>

        <div className="flex flex-col w-1/2">
          <h1 className="text-green-300 text-[30px] text-right w-full pb-3">
            YEGNATELE
          </h1>
          <h1 className="text-gray-400 text-right w-full text-[18px] mb-8">
            SMS and IVR Service Provider
          </h1>

          <div className="bg-[#112240] p-5 ml-[-160px]  rounded-xl text-white z-10  text-center text-[18px] h-48 flex items-center">
            Streamline your communication with our comprehensive SMS and IVR
            solutions. Reach your audience instantly through SMS messages and
            engage them interactively with our robust IVR system. Enhance
            customer engagement, automate processes, and deliver seamless
            experiences with our reliable and scalable SMS and IVR service
          </div>
          <h1 className="w-full text-gray-500 mt-6">
            HTML,CSS,Tailwind, ReactJS , nodeJS ,Express JS,Redux Toolkit ,
            MYSQL,Squelizer, mongoDB{" "}
          </h1>
        </div>
      </div>

      <div className="w-2/3 flex flex-col-2 gap-2  justify-start items-start">
        <div className="flex flex-col w-1/2">
          <h1 className="text-green-300 text-[30px] text-left w-full pb-3">
            TALGUU
          </h1>
          <h1 className="text-gray-400 text-left w-full text-[18px] mb-6">
            Explore, watch, and share captivating videos
          </h1>
          <div className="bg-[#112240] p-5 mr-[-100px]  rounded-xl text-white z-10 text-center text-[18px] h-48 flex items-center">
            A cutting-edge YouTube-like system that offers users a platform to
            discover, watch, and share an endless variety of engaging and
            diverse video content from creators worldwide. With its intuitive
            interface, personalized recommendations, and interactive features,
            this system ensures an immersive and enjoyable viewing experience
            for users of all interests.
          </div>
          <h1 className="w-full text-gray-500 mt-4">
            HTML,CSS,Tailwind, ReactJS , nodeJS ,Express JS,Redux Toolkit ,
            MYSQL,Squelizer, mongoDB{" "}
          </h1>
        </div>

        <div className="w-1/2 hover:z-20 hover:scale-105">
          <GifPlayer
            gif={talguu}
            still={talguuImage}
            className="w-[450px] h-[350px] rounded-lg "
          />
        </div>
      </div>

      <div className="w-2/3 flex flex-col-2 gap-2  justify-start items-start">
        <div className="w-1/2 hover:z-20 hover:scale-105">
          {/* <img
            src={assImage}
            alt="Girl in a jacket"
            width="400"
            height="300"
            className="z-0 rounded-md fill-slate-700 bg-slate-400  grayscale hover:grayscale-0"
          ></img> */}
          <GifPlayer
            gif={ninejobs}
            still={nineImage}
            className="w-[450px] h-[350px] rounded-lg "
          />
        </div>

        <div className="flex flex-col w-1/2">
          <h1 className="text-green-300 text-[30px] text-right w-full pb-3">
            9000Jobs
          </h1>
          <h1 className="text-gray-400 text-right w-full text-[18px] mb-6">
            Simplify your job search with our user-friendly job finding site
          </h1>
          <div className="bg-[#112240] p-5 ml-[-160px]  rounded-xl text-white z-10 text-center text-[18px] h-48 flex items-center">
            Find your perfect job with our job finding service. Discover a wide
            range of career opportunities, connect with top employers, and
            streamline your job search. Get personalized job recommendations,
            stay updated with real-time alerts, and take the next step in your
            professional journey. Simplify your job hunt and find the right fit
            for your skills and aspirations.
          </div>
          <h1 className="w-full text-gray-500 mt-4">
            HTML,CSS,Tailwind, Angular , node js ,Express js
            ,TYPESCRIPT,MYSQL,Squelizer
          </h1>
        </div>
      </div>
    </div>
  );
};
